(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["regenerative-impact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    function adjustLayout() {
      var impactSection = document.getElementById('regenerative-impact');
      var windowWidth = window.innerWidth;
      
      if (windowWidth <= 768) {
        impactSection.classList.add('mobile-layout');
      } else {
        impactSection.classList.remove('mobile-layout');
      }
    }
    
    window.addEventListener('resize', adjustLayout);
    adjustLayout();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  // No JavaScript required for this section

  } catch(e) { console.error(e); }
})();
})();
